import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2950708e&scoped=true"
import script from "./Accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=2950708e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950708e",
  null
  
)

export default component.exports